const doc = [({"en":({"js":({"admin":({"ability_groups":({"edit":({"the_ability_group_was_saved":"The ability group was saved", "new_ability_group":"New ability group"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;